/**
 * Cliente API de categorias (Sprint 13 S13-04, migrado desde
 * frontend-superadmin).
 *
 * Backend: `GET /categorias/?tipo=ingreso&activa=true` para selector
 * de categorias de ingreso en lineas tipo multa / otro_ingreso del
 * modal de clasificacion.
 */
import { apiFetch } from './client';
import type { CategoriaRead, TipoCategoria } from './types';

export function listCategorias(filtros: {
  tipo?: TipoCategoria;
  activa?: boolean;
} = {}): Promise<CategoriaRead[]> {
  const params = new URLSearchParams();
  if (filtros.tipo) params.set('tipo', filtros.tipo);
  if (filtros.activa !== undefined) params.set('activa', String(filtros.activa));
  const qs = params.toString();
  return apiFetch<CategoriaRead[]>(`/categorias/${qs ? `?${qs}` : ''}`);
}
